import React, {Component} from 'react';
import FaQuestionCircle from 'react-icons/lib/fa/question-circle';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import {RingLoader} from 'react-spinners';

import * as actions from '../../../actions';

import {URL} from '../../../config/Config';
import {findElement} from '../../../utils/helpers';
/**
* Import components
*/
import PrevNext from '../../PrevNext';
import FormInput from '../../forms/FormInput';
import FormInputField from '../../forms/FormInputField';
import MixForm from '../../forms/MixForm';
import ImageContainer from '../../image-handler/ImageContainer';

/**
* class StepOne
*/
class ActiveWidthLength extends Component {

    calculateSize(type) {
        if (type === 'lange') {
            if(this.props.bathtub.W_LAENGE.CurrentValue < findElement(this.props.bathtub.W_LAENGE.Values.Range, 'StepSize').LowerLimit){
                return findElement(this.props.bathtub.W_LAENGE.Values.Range, 'StepSize').LowerLimit;
            }
            return (
                parseInt(this.props.bathtub.W_LAENGE.CurrentValue) +
                parseInt((this.props.bathtub.SO81.CurrentValue || 0)) +
                parseInt((this.props.bathtub.SO45.CurrentValue || 0))
            );
        }
        if (type === 'breite') {
            if(this.props.bathtub.W_BREITE.CurrentValue < findElement(this.props.bathtub.W_BREITE.Values.Range, 'StepSize').LowerLimit) {
                return findElement(this.props.bathtub.W_BREITE.Values.Range, 'StepSize').LowerLimit;
            }
            return (
                parseInt(this.props.bathtub.W_BREITE.CurrentValue) +
                parseInt((this.props.bathtub.SO23.CurrentValue || 0)) +
                parseInt((this.props.bathtub.SO67.CurrentValue || 0))
            );
        }
    }

    /**
    * render method
    * @returns {XML}
    */
    render() {
        return (

                <div className='col s12'>
                    <div className='row'>
                        <h5 className='col s6' >
                            {this.props.translate('BATHTUB.stepOne.form.title')}  {this.calculateSize('lange')} cm x {this.calculateSize('breite')} cm
                        </h5>
                        <div className='col s6 right-align'>
                            <FaQuestionCircle style={{fontSize: '20px'}}/>
                        </div>

                    </div>

                    <div className='row'>

                        <FormInput
                            type='number'
                            label={this.props.translate('BATHTUB.stepOne.form.length')}
                            name='BATHTUB.W_LAENGE'
                            value={this.props.bathtub.W_LAENGE.CurrentValue}
                            min={findElement(this.props.bathtub.W_LAENGE.Values.Range, 'StepSize').LowerLimit}
                            max={findElement(this.props.bathtub.W_LAENGE.Values.Range, 'StepSize').UpperLimit}
                            subLabel={`${findElement(this.props.bathtub.W_LAENGE.Values.Range, 'StepSize').LowerLimit} - ${findElement(this.props.bathtub.W_LAENGE.Values.Range, 'StepSize').UpperLimit}`}
                            fieldStyle={{width: '100%', padding: 0}}
                            divClass='col s2' />
                        <div className='col s4 offset-s2'>
                            <FormInput
                                type='number'
                                label='&nbsp;'
                                subLabel='(0 - 0)'
                                name='BATHTUB.SO23'
                                value={this.props.bathtub.SO23.CurrentValue}
                                min={-5}
                                max={7}
                                disabled={true}
                                fieldStyle={{width: '100%', padding: 0}}
                                sublabelStyle={{width: '100%'}}
                                divClass='col s4 offset-s4' />
                        </div>
                            <FormInput
                                type='number'
                                label={this.props.translate('BATHTUB.stepOne.form.width')}
                                value={this.props.bathtub.W_BREITE.CurrentValue}
                                name='BATHTUB.W_BREITE'
                                min={findElement(this.props.bathtub.W_BREITE.Values.Range, 'StepSize').LowerLimit}
                                max={findElement(this.props.bathtub.W_BREITE.Values.Range, 'StepSize').UpperLimit}
                                subLabel={`${findElement(this.props.bathtub.W_BREITE.Values.Range, 'StepSize').LowerLimit} - ${findElement(this.props.bathtub.W_BREITE.Values.Range, 'StepSize').UpperLimit}`}
                                fieldStyle={{width: '100%', padding: 0}}
                                divClass='col s2 offset-s2'/>
                    </div>

                    <div className='col s3'>
                        <FormInput
                            type='number'
                            subLabel='(0 - 0)'
                            value={this.props.bathtub.SO81.CurrentValue}
                            name='BATHTUB.S081'
                            min={0}
                            max={0}
                            disabled={true}
                            sublabelStyle={{width: '100%'}}
                            divClass='col s5 valign-wrapper'
                            fieldStyle={{width: '100%', padding: 0}}/>
                    </div>

                        <div className='col s6'>
                            <ImageContainer
                                image={this.props.image.Image ? this.props.image.Image : ''}
                                name='bathtub'
                                loadingImage={true}
                                height= '100%'/>
                        </div>
                        <div className='col s3'>
                            <FormInput
                                type='number'
                                subLabel='(0 - 0)'
                                value={this.props.bathtub.SO45.CurrentValue}
                                name='BATHTUB.S045'
                                min={0}
                                max={0}
                                disabled={true}
                                sublabelStyle={{width: '100%'}}
                                divClass='col s5 offset-s7 valign-wrapper'
                                fieldStyle={{width: '100%', padding: 0}}/>
                        </div>
                        <div className='col s12'>
                            <div className='col s8 offset-s2'>
                                <FormInput
                                    type='number'
                                    subLabel='(0 - 0)'
                                    value={this.props.bathtub.SO67.CurrentValue}
                                    name='BATHTUB.S067'
                                    min={0}
                                    max={0}
                                    disabled={true}
                                    fieldStyle={{width: '100%', padding: 0}}
                                    sublabelStyle={{width: '100%'}}
                                    divClass='col s2 offset-s5' />
                            </div>
                        </div>
                    </div>
        )
    }

}

ActiveWidthLength.propTypes = {
    lastStep:    PropTypes.number,
    translate:   PropTypes.func,
    bathtub:     PropTypes.object,
    isValidFrom: PropTypes.bool,
    fetchData:   PropTypes.func.isRequired,
}

function mapStateToProps({locale, bathtub, image, isvalidfrom}) {
    return {
        translate:      getTranslate(locale),
        currentLanguge: getActiveLanguage(locale).code,
        bathtub,
        image,
        isvalidfrom,
    }
}

export default connect(mapStateToProps, actions)(ActiveWidthLength);




// WEBPACK FOOTER //
// ./src/components/bathtub-steps/StepOne/ActiveWidthLength.js